import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m5.4 6.2 8.3 8.4 3.7-3.7c1-1 1-2.5 0-3.5l-4.8-4.8c-1-1-2.6-1-3.5 0zm2.4 0 2.4-2.4c.4-.3.9-.3 1.2 0l4.8 4.8c.3.3.3.8 0 1.2l-2.4 2.4z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.4 14.9c-1 1-2.5 1-3.5 0l-.4-.4a.4.4 0 0 0-.6 0l-2 2.5a2.8 2.8 0 1 1-4-4l2.6-1.9c.2-.1.2-.4 0-.6l-.4-.4c-1-1-1-2.6 0-3.5L6.7 5l8.3 8.3zm-5.8-1.4-2 2.5A1.2 1.2 0 1 1 4 14.3l2.5-1.9c1-.7 1-2.2.2-3l-.4-.5a.8.8 0 0 1 0-1.2l.3-.3 6 6-.3.3c-.4.3-.9.3-1.2 0l-.4-.4a2 2 0 0 0-3.1.2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }